import { Getters } from 'vuex-smart-module';
import EquipmentState from './state';

export default class EquipmentGetters extends Getters<EquipmentState> {
  get equipment() {
    return this.state.equipment;
  }

  get totalItems() {
    return this.state.pagination_props.total_items;
  }

  get tableOptions() {
    return this.state.table_options;
  }

  get loading() {
    return this.state.loading;
  }
}
